import React from 'react';
import styled from 'styled-components';

import {
  COLOR_BLACK,
  COLOR_SPOTIFY_GREEN,
} from 'client/components/MarketingPagesShared/styles';
import { AnchorLogoWithWordmark } from 'client/components/svgs/AnchorLogoWithWordmark';
import { PODCAST_COLORS } from 'client/utils';
import { RetinaPicture } from 'client/components/RetinaPicture';
import { useT } from 'client/i18n/hooks/useT';

const MeetAnchorSection = styled.section`
  background: ${COLOR_BLACK};
  width: 100%;
  padding: 100px 24px 60px;
`;

const MeetAnchorContainer = styled.div`
  margin: 0 auto 40px;
  width: 100%;
  max-width: 985px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const MeetAnchorContentContainer = styled.div`
  margin-left: 110px;
  h2 {
    font-size: 3.125rem;
    line-height: 55px;
    color: ${COLOR_SPOTIFY_GREEN};
    text-transform: uppercase;
    margin: 0 0 25px;
  }
  p {
    font-size: 1.125rem;
    line-height: 26px;
    color: ${PODCAST_COLORS.WHITE.color};
    margin: 0;
  }
`;

const AnchorSVGWrapper = styled.div`
  width: 100%;
  max-width: 1440px;
  text-align: end;
  margin: 0 auto;

  svg {
    width: 100%;
    max-width: 166px;
  }
`;

export function MeetAnchor() {
  const t = useT();

  // TODO https://anchorfm.atlassian.net/browse/CAST-2750: Final copy update and translate
  const title = t(
    'IntegrationConnectionScreen.MeetAnchor.Title',
    'Meet Anchor by Spotify',
    'The title for the Meet Anchor section on the Integration Connection Screen'
  );
  const body = t(
    'IntegrationConnectionScreen.MeetAnchor.Body',
    "Anchor is Spotify's free creation platform, powering more new podcasts than any other platform in the world. It's the destination for all things podcasting: Easily create, distribute, and monetize your show through Anchor—all for free. Once your show is uploaded, it's available to enjoy on Spotify.",
    'The body for the Meet Anchor section on the Integration Connection Screen'
  );
  return (
    <MeetAnchorSection>
      <MeetAnchorContainer>
        {/* TODO https://anchorfm.atlassian.net/browse/CAST-2756: Update final image */}
        <RetinaPicture
          imagePath="/span/span-headphones-lady"
          alt={t(
            'AdsByAnchorScreen.BrandPartners.MarketingImageAlt',
            'Woman listening to a podcast while looking at her phone',
            'Ads by Anchor page, brand partners marketing image screenreader information'
          )}
          fallbackExtension="jpg"
        />
        <MeetAnchorContentContainer>
          <h2>{title}</h2>
          <p>{body}</p>
        </MeetAnchorContentContainer>
      </MeetAnchorContainer>
      <AnchorSVGWrapper>
        <AnchorLogoWithWordmark
          ariaLabel={t(
            'svgs.AnchorLogoWithWordmark.BySpotify',
            'by Spotify',
            'Anchor logo with "by Spotify" added after it'
          )}
          includeSpotify={true}
          fillColor={PODCAST_COLORS.WHITE.color}
        />
      </AnchorSVGWrapper>
    </MeetAnchorSection>
  );
}
